import { PureComponent } from 'react';

import { FormattedMessage } from 'react-intl';

import Panel from '@atlaskit/panel';

import MarkupFileRenderer from '../containers/markup-file-renderer';

import messages from './error-state.i18n';
import { RenderProps } from './markup-file-renderer';
import * as styles from './readme.style';

export type ReadmeProps = {
  path: string;
};

export class Readme extends PureComponent<ReadmeProps> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    contents: [],
  };

  render() {
    const { path } = this.props;
    const name = path.split('/').pop();

    return (
      <MarkupFileRenderer
        errorDescription={
          <FormattedMessage tagName="p" {...messages.errorDescriptionReadme} />
        }
        path={path}
        render={({ markupAsRawHtml }: RenderProps) => (
          <Panel
            header={
              <span>
                <styles.ReadmeHeader>{name}</styles.ReadmeHeader>
              </span>
            }
            isDefaultExpanded
          >
            <styles.ReadmeContainer
              dangerouslySetInnerHTML={{ __html: markupAsRawHtml }}
              data-qa="readme-container"
            />
          </Panel>
        )}
      />
    );
  }
}
